<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal scrollable size="md" :visible="modal.show"
                   :title="authenticatorCreated ? $t('Change Authenticator App') : $t('Add Authenticator App')"
                   modal-class="mobile-full-screen" :ok-title="$t('Submit')" @ok.prevent="handleSubmit(onSubmit)"
                   @hidden="onHide()"
                   :disable-submit-btn="modal.loading">
      <template v-if="modal.loading">
        <spinner show height="20" size="5"/>
      </template>
      <template v-if="modal.url">
        <div class="row">
          <div class="col-md-12">
            <p v-if="authenticatorCreated">
              {{ $t(`You won't be able to use old authenticator app.`) }}
            </p>
            <ul>
              <li>{{ $t('In the Authenticator app, click +/Add New)') }}</li>
              <li>{{ $t('Choose') }} <b>{{ $t('Scan a QR Code') }}</b></li>
              <li>{{ $t('After scanning enter generated code below and click submit.') }}</li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <img :src="modal.url" class="qr-image"/>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <input-widget :model="model" attribute="code" type="text"/>
          </div>
        </div>
      </template>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import CancelModalSelectComponent from "@/modules/invoices/CancelModalSelectComponent.vue";
import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal.vue";
import ArtisioTable from "@/core/components/ams-table/ArtisioTable.vue";
import LiveSaleRef from "@/core/components/common/LiveSaleRef.vue";
import Spinner from "@/core/components/common/Spinner.vue";
import InputWidget from "@/core/components/input-widget/InputWidget.vue";
import AuthenticatorCodeModel from "@/modules/auth/Profile/AuthenticatorCodeModel";

const {mapState, mapActions} = createNamespacedHelpers('profile');


export default {
  name: "AuthenticatorModal",
  components: {InputWidget, Spinner, LiveSaleRef, ArtisioTable, ArtisioModal, CancelModalSelectComponent},

  data() {
    return {
      model: null
    }
  },
  computed: {
    ...mapState({
      modal: state => state.authenticatorModal,
      authenticatorCreated: state => state.authenticatorCreated,
    }),
  },
  methods: {
    ...mapActions(['hideAuthenticatorModal', 'getAuthenticatorData', 'submitAuthenticatorToken']),
    onHide() {
      this.model = new AuthenticatorCodeModel();
      this.hideAuthenticatorModal();
    },
    async onSubmit() {
      const response = await this.submitAuthenticatorToken(this.model.code);
      if (response.success) {
        this.$toast('success', this.$i18n.t('Authenticator app was successfully added.'));
        this.getAuthenticatorData();
        this.hideAuthenticatorModal();
      } else {
        this.$toast('danger', response.body.error ? response.body.error : this.$i18n.t('Error when adding authenticator app. Please try again.'));
      }
    }
  },
  mounted() {
    this.model = new AuthenticatorCodeModel();
  }
}
</script>

<style scoped lang="scss">

.qr-image {
  width: 200px;
  display: block;
  margin: 8px auto;
}
</style>
